import React from 'react';
import { EmergencyRepair } from 'pages/Search/models';
import { useDispatch, useSelector } from 'react-redux';
import { Descriptions, Typography, Row, Tooltip, Checkbox } from 'antd';
import { formatPriceString, getDataTypeName, tabSelector } from 'common';
import { searchIsSelectedUpdate, isSelectedSelector } from 'pages/Search';
import { createSelector } from 'reselect';
import { ResultTypeName } from 'pages/Search/Search.types';

const { Text } = Typography;

const selector = createSelector(
  tabSelector,
  isSelectedSelector,
  (tabName, getIsSelected) => ({
    tabName,
    getIsSelected,
  }),
);

const EmergencyRepairsListItem: React.FC<{
  er: EmergencyRepair;
  index: number;
  resultType: ResultTypeName;
  resultItemIndex: number;
}> = ({ er, index, resultType, resultItemIndex }) => {
  const { street, streetCode, fileNumber, amount, guid, county, documentType } =
    er;
  const dispatch = useDispatch();
  const { tabName, getIsSelected } = useSelector(selector);

  const onChange = ({ target: { checked } }: any) => {
    dispatch(
      searchIsSelectedUpdate(
        getDataTypeName(tabName),
        documentType,
        guid,
        checked,
        resultItemIndex,
        resultType,
      ),
    );
  };

  const isSelected = React.useMemo(() => {
    return getIsSelected(
      getDataTypeName(tabName),
      documentType,
      guid,
      resultItemIndex,
      resultType,
    );
  }, [documentType, getIsSelected, guid, resultItemIndex, resultType, tabName]);

  return (
    <Descriptions
      size={'small'}
      title={
        <Row type="flex" justify="start" align="middle">
          <Text>
            #{index + 1}&nbsp;
            <Tooltip title={'Check for export'}>
              <Checkbox
                onChange={onChange}
                defaultChecked={true}
                checked={isSelected}
              />
            </Tooltip>
          </Text>
        </Row>
      }
    >
      <Descriptions.Item label="Street Code">{streetCode}</Descriptions.Item>
      <Descriptions.Item label="Street">{street}</Descriptions.Item>

      <Descriptions.Item label="File Number">{fileNumber}</Descriptions.Item>
      <Descriptions.Item label="Amount">
        {formatPriceString(amount)}
      </Descriptions.Item>
      <Descriptions.Item label="County">{county}</Descriptions.Item>
    </Descriptions>
  );
};

export default EmergencyRepairsListItem;
